module.exports = __webpack_public_path__ + "img/sail_code.40aa415e.png";